var map = {
	"./buddy": "./app/javascript/images/buddy.png",
	"./buddy.png": "./app/javascript/images/buddy.png",
	"./buddy_spido": "./app/javascript/images/buddy_spido.png",
	"./buddy_spido.png": "./app/javascript/images/buddy_spido.png",
	"./footer": "./app/javascript/images/footer.png",
	"./footer.png": "./app/javascript/images/footer.png",
	"./header": "./app/javascript/images/header.png",
	"./header.png": "./app/javascript/images/header.png",
	"./logo": "./app/javascript/images/logo.png",
	"./logo.png": "./app/javascript/images/logo.png",
	"./logo_inverted": "./app/javascript/images/logo_inverted.png",
	"./logo_inverted.png": "./app/javascript/images/logo_inverted.png",
	"./spido": "./app/javascript/images/spido.png",
	"./spido.png": "./app/javascript/images/spido.png",
	"./video_buddy_spido": "./app/javascript/images/video_buddy_spido.jpg",
	"./video_buddy_spido.jpg": "./app/javascript/images/video_buddy_spido.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";